module.exports = __webpack_public_path__ + "cn.svg?3a0829042f88f0dd20060d30fd7057c2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/cn.svg
// module id = 1050
// module chunks = 0